function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Photo2_svg__clip0_1818_35496)",
  fill: "#28293D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.208 15.443a3.12 3.12 0 01-2.952-2.126l-.029-.096a3.042 3.042 0 01-.144-.903V6.636L.06 13.384a1.893 1.893 0 001.327 2.296l12.886 3.451c.16.042.322.062.48.062.83 0 1.588-.551 1.801-1.363l.75-2.387H5.209zM7.5 6.693c.919 0 1.666-.748 1.666-1.667 0-.92-.747-1.667-1.666-1.667-.92 0-1.667.748-1.667 1.667 0 .92.748 1.667 1.667 1.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.917.858h-12.5a2.086 2.086 0 00-2.084 2.084v9.167c0 1.148.935 2.083 2.083 2.083h12.5A2.086 2.086 0 0020 12.11V2.942A2.086 2.086 0 0017.917.858zm-12.5 1.667h12.5c.23 0 .416.187.416.417v5.916l-2.632-3.072a1.493 1.493 0 00-1.118-.512 1.456 1.456 0 00-1.113.525l-3.095 3.715L9.366 8.51a1.463 1.463 0 00-2.066 0L5 10.808V2.942c0-.23.186-.417.416-.417z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Photo2_svg__clip0_1818_35496"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgPhoto2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPhoto2;